import { createNewNote, findNoteHelper } from './noteHelpers'
import * as ace from 'ace-builds/src-noconflict/ace'
import store from '../../store'
import router from '../../router'
import { Dialog } from 'quasar'
import { expandNoteIdInTree } from './sessionsHelper'
import Vue from 'vue'

/**
 * Deletes a note permanently
 * @param noteId
 */
export function deleteNote (noteId) {
  const noteHelper = findNoteHelper(noteId)
  Dialog.create({
    title: 'Delete note \'' + noteHelper.name + '\'?',
    message: 'Are you sure you want to delete this note?',
    // position: 'top',
    ok: 'Delete It',
    cancel: 'Cancel'
  }).onOk(() => {
    // What if it has children!?!?!?
    // They confirmed the deletion!
    // if we have the deleted note open, navigate elsewhere!
    // router.replace('/home')
    return store.dispatch('deleteItemWithId', noteId)
  })
}

export function newSubNote (parentId) {
  // return this.$refs.chooseTemplateModal.show().then(noteTemplate => {
  const userData = {} // noteTemplate ? { templateId: noteTemplate.id } : {}
  let newItem = { data: '# New note\nNote content goes here.', userData: userData, children: [] }
  createNewNote(newItem, parentId).then(async (newHelper) => {
    await expandNoteIdInTree(parentId)
    const editor = await navigateToNote(newHelper.noteId)
    let range = new ace.Range(0, 2, 1, 23)
    editor.session.selection.setRange(range)
    editor.focus()
  })
  // })
}

/**
 * Sets the currently selected note id by updating the store and navigating to that page
 * @param noteId
 * @returns {Promise<Route>}
 * @private
 */
export function _setSelectedTreeItemId (noteId) {
  if (noteId == null) return
  store.commit('updateSelectedTreeItemId', noteId)
  return router.push('/home/' + noteId)
}

export function navigateToNote (noteId) {
  if (noteId == null) return Promise.resolve()
  return new Promise((resolve, reject) => {
    _setSelectedTreeItemId(noteId).then((aa, bb) => {
      const page = window._vue.$children[0].$children[0].$refs['page']
      if (page.$refs['acedata'] === undefined) {
        Vue.nextTick(() => {
          const page = window._vue.$children[0].$children[0].$refs['page']
          if (page.$refs['acedata'] === undefined) {
            reject(Error('Editor not found'))
            return
          }
          const editor = (page.$refs['acedata'][0] || {}).editor
          resolve(editor, page)
        })
      } else {
        const editor = (page.$refs['acedata'][0] || {}).editor
        resolve(editor, page)
      }
    })
  })
}
